import type { DocumentRevision, PhysicalLocation } from './types';
import { DocumentRevisionStatus, type Option } from '@/shared/lib';

// ==================== MOCK DATA ====================

const mockPhysicalLocation: PhysicalLocation = {
  id: 1,
  name: 'Localização Física Padrão',
  description: 'Localização física padrão para documentos',
  createdAt: new Date('2024-01-01'),
  updatedAt: new Date('2024-01-01'),
};

export const PENDING_DOCUMENTS: DocumentRevision[] = [
  {
    id: 1,
    createdAt: '2024-04-01',
    updatedAt: '2024-04-01',
    revision: 1,
    documentId: 1,
    validityDate: '2027-02-01',
    effectiveDate: '2027-02-01',
    approvalDate: '2024-04-01',
    approvedAt: '2024-04-01',
    status: DocumentRevisionStatus.PENDING_APPROVAL,
    docUrl: null,
    physicalLocations: [{ id: mockPhysicalLocation.id, name: mockPhysicalLocation.name, distribution: { quantity: 1 } }],
    positions: [
      {
        id: 1,
        name: 'Cargo 01',
      },
    ],
    training: {
      programmed: true,
      trainingJustification: null,
    },
    stage: null,
    document: {
      id: 1,
      name: 'Política de Tratamento de reclamação de admins',
      createdAt: '2024-04-01',
      updatedAt: '2024-04-01',
      prefix: 'DOC',
      docPath: 'caminho-para-documento/1',
      requestDate: '2024-11-23',
      type: 'DOCUMENT',
      userId: 1,
      user: {
        name: 'Renato Abreu',
      },
    },
    changelogEntries: [
      {
        id: 1,
        createdAt: '2024-04-01',
        updatedAt: '2024-04-01',
        documentRevisionId: 1,
        description: 'Changelog 01',
      },
    ],
  },
  {
    id: 2,
    createdAt: '2024-04-01',
    updatedAt: '2024-04-01',
    validityDate: '2027-02-01',
    effectiveDate: '2027-02-01',
    approvalDate: '2024-04-01',
    approvedAt: '2024-04-01',
    status: DocumentRevisionStatus.PENDING_VERIFICATION,
    docUrl: null,
    physicalLocations: [{ id: mockPhysicalLocation.id, name: mockPhysicalLocation.name, distribution: { quantity: 1 } }],
    stage: null,
    positions: [
      {
        id: 1,
        name: 'Cargo 01',
      },
    ],
    training: {
      programmed: true,
      trainingJustification: null,
    },
    revision: 2,
    documentId: 1,
    document: {
      id: 1,
      name: 'Política de Tratamento de reclamação de admins',
      createdAt: '2024-04-01',
      updatedAt: '2024-04-01',
      prefix: 'DOC',
      docPath: 'caminho-para-documento/1',
      requestDate: '2024-11-23',
      type: 'DOCUMENT',
      userId: 1,
      user: {
        name: 'Renato Abreu',
      },
    },
    changelogEntries: [
      {
        id: 2,
        createdAt: '2024-04-01',
        updatedAt: '2024-04-01',
        documentRevisionId: 2,
        description: 'Changelog 02',
      },
    ],
  },
  {
    id: 3,
    createdAt: '2024-04-01',
    updatedAt: '2024-04-01',
    validityDate: '2027-02-01',
    effectiveDate: '2027-02-01',
    approvalDate: '2024-04-01',
    approvedAt: '2024-04-01',
    status: DocumentRevisionStatus.VERIFIED,
    docUrl: null,
    physicalLocations: [{ id: mockPhysicalLocation.id, name: mockPhysicalLocation.name, distribution: { quantity: 1 } }],
    stage: null,
    positions: [
      {
        id: 1,
        name: 'Cargo 01',
      },
    ],
    training: {
      programmed: true,
      trainingJustification: null,
    },
    revision: 3,
    documentId: 1,
    document: {
      id: 1,
      name: 'Política de Tratamento de reclamação de admins',
      createdAt: '2024-04-01',
      updatedAt: '2024-04-01',
      prefix: 'DOC',
      docPath: 'caminho-para-documento/1',
      requestDate: '2024-11-23',
      type: 'DOCUMENT',
      userId: 1,
      user: {
        name: 'Renato Abreu',
      },
    },
    changelogEntries: [
      {
        id: 2,
        createdAt: '2024-04-01',
        updatedAt: '2024-04-01',
        documentRevisionId: 3,
        description: 'Changelog 02',
      },
    ],
  },
  {
    id: 4,
    createdAt: '2024-04-01',
    updatedAt: '2024-04-01',
    validityDate: '2027-02-01',
    effectiveDate: '2027-02-01',
    approvalDate: '2024-04-01',
    status: DocumentRevisionStatus.CURRENT,
    docUrl: null,
    physicalLocations: [{ id: mockPhysicalLocation.id, name: mockPhysicalLocation.name, distribution: { quantity: 1 } }],
    stage: null,
    positions: [
      {
        id: 1,
        name: 'Cargo 01',
      },
    ],
    training: {
      programmed: true,
      trainingJustification: null,
    },
    approvedAt: '2024-04-01',
    revision: 3,
    documentId: 1,
    document: {
      id: 1,
      name: 'Política de Tratamento de reclamação de admins',
      createdAt: '2024-04-01',
      updatedAt: '2024-04-01',
      prefix: 'DOC',
      docPath: 'caminho-para-documento/1',
      requestDate: '2024-11-23',
      type: 'DOCUMENT',
      userId: 1,
      user: {
        name: 'Renato Abreu',
      },
    },
    changelogEntries: [
      {
        id: 2,
        createdAt: '2024-04-01',
        updatedAt: '2024-04-01',
        documentRevisionId: 3,
        description: 'Changelog 03',
      },
    ],
  },
];

export const APPROVALS = PENDING_DOCUMENTS.map((doc) => ({
  id: doc.id,
  justification: doc.changelogEntries.map((changeLogEntry) => changeLogEntry.description),
  userId: doc.document?.userId,
  documentId: doc.id,
  document: doc,
  user: doc.document?.user,
}));

export const VERIFICATIONS = PENDING_DOCUMENTS.map((doc) => ({
  id: doc.id.toString(),
  name: doc.document?.name,
  revision: doc.revision,
  type: doc.document?.type,
  documentId: doc.id.toString(),
  owner: doc.document?.user?.name || '',
  requestDate: doc.createdAt,
  approval: 'Aguardando aprovação',
  changelog: doc.changelogEntries.map((changeLogEntry) => changeLogEntry.description) || '',
  createdAt: doc.createdAt,
  updatedAt: doc.updatedAt,
}));

export const REVISIONS = [
  {
    number: 'Número da revisão - dd/mm/aa',
    changes: [
      'Alteração 01: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 02: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 03: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 04: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    ],
  },
  {
    number: 'Número da revisão - dd/mm/aa',
    changes: [
      'Alteração 01: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 02: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 03: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 04: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    ],
  },
  {
    number: 'Número da revisão - dd/mm/aa',
    changes: [
      'Alteração 01: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 02: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 03: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 04: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    ],
  },
  {
    number: 'Número da revisão - dd/mm/aa',
    changes: [
      'Alteração 01: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 02: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 03: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      'Alteração 04: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    ],
  },
];

// ==================== TABLE HEADERS ====================

export const HEADERS = [
  'Nome do Documento',
  'Rev.',
  'Status',
  'Vigência',
  'Validade',
  'Formato',
  'Local HTM',
  'Módulo',
  'Ações',
];

// ==================== LISTA MESTRA ====================

export const PREDEFINED_DATES: Option[] = [
  {
    id: 'todas',
    name: 'Todas',
  },
  {
    id: '01/2025',
    name: '01/2025',
  },
  {
    id: '02/2025',
    name: '02/2025',
  },
  {
    id: '03/2025',
    name: '03/2025',
  },
];
